import { useContext, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';
import './index.css';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import {
  Dashboard,
  Login,
  Meeting,
  MeetingDetail,
  ResetPasswordPage,
  Ruangan,
  RuanganDetail,
  User,
  Callback,
  NotFound,
  Food,
  Reporting,
  MeetingInformations
} from "./pages";
import { AuthContext, PrivateRouteComp } from "./auth";


const MeetingChecker = () => {
  const { retrieveMeeting, tokens } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      if (tokens?.token !== undefined && location.pathname !== "/informasi-meeting/" && location.pathname !== "*") {
        retrieveMeeting(false);
      } else if (tokens?.token !== undefined && location.pathname === "/informasi-meeting/") {
        retrieveMeeting(true);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [tokens, location.pathname, retrieveMeeting]);

  return null;
};


function App() {

  return (
    <BrowserRouter>
      <MeetingChecker />
      <Routes>
        <Route path="/"
          element={
            // <PublicRoute >
            // </PublicRoute>
            <Login />
          } />
        <Route path="/dashboard/"
          element={
            <PrivateRouteComp >
              <Dashboard />
            </PrivateRouteComp>
          } />
        <Route path="/reporting/"
          element={
            <PrivateRouteComp >
              <Reporting />
            </PrivateRouteComp>
          } />
        <Route path="/callback"
          element={<Callback />
          } />
        <Route path="/user/"
          element={
            <PrivateRouteComp >
              <User />
            </PrivateRouteComp>
          } />
        <Route path="/makanan/"
          element={
            <PrivateRouteComp >
              <Food />
            </PrivateRouteComp>
          } />
        <Route path="/ruangan/"
          element={
            <PrivateRouteComp >
              <Ruangan />
            </PrivateRouteComp>
          } />
        <Route path="/detail-ruangan/:ruangid"
          element={
            <PrivateRouteComp >
              <RuanganDetail />
            </PrivateRouteComp>
          } />
        <Route path="/meeting/"
          element={
            <PrivateRouteComp >
              <Meeting />
            </PrivateRouteComp>
          } />
        <Route path="/detail-meeting/:meetingid"
          element={
            <PrivateRouteComp >
              <MeetingDetail />
            </PrivateRouteComp>
          } />
        {/* <Route path="/informasi-meeting/"
          element={

            <MeetingInformations />

          } /> */}
        <Route path="/informasi-meeting/:token/"
          element={
            <MeetingInformations />
          } />
        <Route path="/reset-password/:userId/:token"
          element={
            <ResetPasswordPage />
          } />
        <Route path="*"
          element={
            <NotFound />
          }
        />
      </Routes>

    </BrowserRouter>
  );
}

export default App;
